import React from 'react';
import { Link } from 'react-router-dom';
import { LinkedinIcon, MailIcon } from 'lucide-react';
import { Button } from './Button';
import { LogoMark } from './LogoMark';
import { NAV_LINKS, LOGO_DARK, CONTACT_EMAIL, LINKEDIN_LABEL, DISCLAIMER } from '../data/site';
interface FooterProps {
  onDownload: () => void;
}
export function Footer({
  onDownload
}: FooterProps) {
  return <footer className="w-full border-t border-charcoal/10 bg-sand" data-id="element-24">
      <div className="mx-auto max-w-7xl px-5 py-14 lg:px-8" data-id="element-25">
        <div className="grid gap-10 md:grid-cols-12" data-id="element-26">
          <div className="md:col-span-5" data-id="element-27">
            <img src={LOGO_DARK} alt="Mine Geology Systems" className="h-8 w-auto" data-id="element-28" />
            <p className="mt-5 max-w-sm text-sm leading-relaxed text-warmgray" data-id="element-29">
              A practical framework for mine geologists who want clearer inputs,
              better interpretation, stronger decisions, better feedback loops
              and continuous improvement across complex geological systems.
            </p>
            <div className="mt-5 flex flex-col gap-2.5" data-id="element-30">
              <a href={`mailto:${CONTACT_EMAIL}`} className="inline-flex items-center gap-2 text-sm font-medium text-charcoal/75 hover:text-charcoal" data-id="element-31">
                <MailIcon className="h-4 w-4" data-id="element-32" />
                {CONTACT_EMAIL}
              </a>
              <a href="#linkedin" className="inline-flex items-center gap-2 text-sm font-medium text-charcoal/75 hover:text-charcoal" data-id="element-33">
                <LinkedinIcon className="h-4 w-4" data-id="element-34" />
                {LINKEDIN_LABEL}
              </a>
            </div>
          </div>

          <div className="md:col-span-3" data-id="element-35">
            <h2 className="flex items-center gap-2 text-xs font-bold uppercase tracking-widest text-charcoal" data-id="element-36">
              <LogoMark className="h-3.5 w-3.5" data-id="element-37" /> Explore
            </h2>
            <ul className="mt-4 space-y-2.5" data-id="element-38">
              {NAV_LINKS.map(link => <li key={link.href} data-id="element-39">
                  <Link to={link.href} className="text-sm text-warmgray transition-colors hover:text-charcoal" data-id="element-40">
                    {link.label}
                  </Link>
                </li>)}
            </ul>
          </div>

          <div className="md:col-span-4" data-id="element-41">
            <h2 className="text-xs font-bold uppercase tracking-widest text-charcoal" data-id="element-42">
              Start with the framework
            </h2>
            <p className="mt-4 text-sm leading-relaxed text-warmgray" data-id="element-43">
              Get the framework, checklist and future case studies in your
              inbox.
            </p>
            <Button variant="primary" onClick={onDownload} className="mt-4" data-id="element-44">
              Download the MGS Toolkit
            </Button>
          </div>
        </div>

        <p className="mt-12 border-t border-charcoal/10 pt-6 text-xs leading-relaxed text-warmgray/80" data-id="element-45">
          {DISCLAIMER}
        </p>

        <div className="mt-6 flex flex-col gap-3 text-xs text-warmgray md:flex-row md:items-center md:justify-between" data-id="element-46">
          <p data-id="element-47">
            © {new Date().getFullYear()} Mine Geology Systems. All rights
            reserved.
          </p>
          <div className="flex gap-6" data-id="element-48">
            <a href="#privacy" className="hover:text-charcoal" data-id="element-49">
              Privacy
            </a>
            <a href="#terms" className="hover:text-charcoal" data-id="element-50">
              Terms
            </a>
            <Link to="/contact" className="hover:text-charcoal" data-id="element-51">
              Contact
            </Link>
          </div>
        </div>
      </div>
    </footer>;
}